var map = {
	"./decidim/simple_ui/decidim_simple_ui.svg": 4834,
	"./decidim/simple_ui/mpassid-nofill.svg": 1847,
	"./decidim/simple_ui/mpassid-white.svg": 4456,
	"./decidim/simple_ui/suomifi-nofill.svg": 394,
	"./decidim/simple_ui/suomifi-white.svg": 9999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6135;